import { render, staticRenderFns } from "./language-menu.vue?vue&type=template&id=54e01025&"
import script from "./language-menu.vue?vue&type=script&lang=js&"
export * from "./language-menu.vue?vue&type=script&lang=js&"
import style0 from "./_language-menu.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports